import { render } from "./ParentTabComponentAgency.vue?vue&type=template&id=3acc38f6"
import script from "./ParentTabComponentAgency.vue?vue&type=script&lang=js"
export * from "./ParentTabComponentAgency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__